import axios from 'axios'
import {
  PointModel,
  EquipmentByPointModel,
  ServiceByPointModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
} from '../model'
import {TableResumen} from '../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getPoint(dto: PointModel, page: number) {
  return axios.post<ResponseObjectPaginated<PointModel[]>>(`${BASEURL}/point/getAll/${page}`, dto)
}
export function getPointById(dto: string | undefined) {
  return axios.get<ResponseObject<PointModel>>(`${BASEURL}/point/getInformationById?pointId=${dto}`)
}

export function createPoint(dto: PointModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/point/createPoint`, dto)
}

export function deletePoint(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/point/deletePoint?id=${dto}`)
}

export function updatePoint(dto: PointModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/point/updatePoint`, dto)
}

// INICIO ---- SERVICIOS MASIVE

// export function downloadTemplatePoint() {
//   return axios.post<ResponseObjectURL>(`${BASEURL}/point/downloadTemplateBulkLoad`)
// }

export function uploadMasivePoint(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/point/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE

// INICIO ---- ASIGNAR MAQUINARIAS

export function getAssignMachine(dto: any, page: number) {
  return axios.post<ResponseObjectPaginated<EquipmentByPointModel[]>>(
    `${BASEURL}/point/getAllMachines/${page}?puntoId=${dto}`,
  )
}

export function createAssignMachine(dto: EquipmentByPointModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/point/assignMachines`, dto)
}

export function deleteAssignMachine(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/point/deleteMachines`, dto)
}

// FIN ---- ASIGNAR MAQUINARIAS

// INICIO ---- ASIGNAR SERVICIOS

export function getAssignService(dto: any, page: number) {
  return axios.post<ResponseObjectPaginated<ServiceByPointModel[]>>(
    `${BASEURL}/point/getAllServices/${page}?puntoId=${dto}`,
  )
}

export function createAssignService(dto: ServiceByPointModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/point/assignServices`, dto)
}

export function deleteAssignService(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/point/deleteServices`, dto)
}

// FIN ---- ASIGNAR SERVICIOS

export function downloadTemplatePoint() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/point/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
